import React, { Component } from 'react'
import { Title } from 'components/misc'
import { ElevatedButton, Header, LayoutPlain } from 'components/layout'
import { meta } from 'helpers/decorators'
import { get } from 'lodash'
import config from 'config'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import PropTypes from 'prop-types'

@meta({
  title: 'Participant registration fees payment',
  intlKey: 'moduleTitle.payment'
})
@connect(
 null,
  {
    push
  }
)
class PaymentGPFail extends Component {
  static propTypes = {
    notification: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired
  }

  handleRedirect = (authCode, orgId) => {
    const paymentUrl = authCode && orgId
      && `${config.publicPath}/gp-init/${orgId}/${authCode}`

    if (paymentUrl) {
      this.props.push(paymentUrl)
    } else {
      this.props.notification(
        'Cannot fetch Online Payment Authorization Code from API',
        {
          status: 'error'
        }
      )
    }
  }

  render() {
    const authCode = get(this.props, 'params.authCode')
    const orgId = get(this.props, 'params.orgId')

    return (
      <LayoutPlain greyBg header={<Header />}>
        <Title h1 intlKey="moduleTitle.payment" className="base-margin--top">
          Participant registration fees payment
        </Title>
        <Title h3 intlKey="label.problem_with_payment">
          There was a problem processing your payment. Please contact your
          National Award Operator (NAO).
        </Title>

        {authCode && orgId &&
        <div>
          <ElevatedButton
            intlKey='button.pay_now'
            uppercase
            rounded
            onClick={() => this.handleRedirect(authCode, orgId)}
          >
            Pay Now
          </ElevatedButton>
        </div>}
      </LayoutPlain>
    )
  }
}

export default PaymentGPFail
